var map = {
	"./Serro_Ref1.png": "7ace",
	"./Serro_Ref2.png": "8095",
	"./building-entry.jpg": "1b73",
	"./building-hall.jpg": "c608",
	"./lift-entrance-opened.jpg": "a483",
	"./lift-entrance.jpg": "527b",
	"./lift-exit.jpg": "3c26",
	"./lift-panel-exit.jpg": "702d",
	"./lift-panel-serro.jpg": "8e90",
	"./lift-panel-xray.jpg": "8ebb",
	"./lift-panel.jpg": "cf2d",
	"./ref1.png": "ee66",
	"./ref2.png": "c773",
	"./ref3.png": "6d8e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";